import script from "./AuthPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthPage.vue?vue&type=script&setup=true&lang=ts"

import "./AuthPage.vue?vue&type=style&index=0&id=717dd85e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717dd85e"]])

export default __exports__